featuresHandler = {
    $featureTitle = $('.feature-title'),
    $featureImageContainer = $('.feature-image-container'),
    $triggerFtImgSmall = $('.trigger-ft-img-small'),
    $panelFeatures = $('.panel-features'),
    $noteText = $('.note-text'),
    $window = $(window),
    isOnLoad = false,
    lastWindowWidth = $window.width(),
    resizeTimeout = null,

    showFeatureImage = function(id, show=false) {
        this.$featureImageContainer.find('.feature-image[data-id='+id+']').each(function() {
            if (show) {
                $(this).removeClass('hidden');
            } else {
                $(this).addClass('hidden');
            }
        });
    },

    showFeatureImageSmall = function(id, show=false, scrollTo=true) {
        var $imageBox = $('.feature-image-box[data-id='+id+']');
        var $trigger = $('.feature-title[data-id='+id+']');
        var $animateParent = $imageBox.closest('.item-animate-container');
        var imageHeight = 0;
        $imageBox.children().each(function() {
            imageHeight += $(this).outerHeight();
        });
        imageHeight += 16; // give some wiggle room!
        var titleHeight = parseInt($trigger.data('height'));
        if (show) {
            $trigger.data('status', 1);
            $trigger.addClass('opened');
            $animateParent.animate({
                height: (imageHeight+titleHeight)+'px'
            }, 250);
            $imageBox.animate({
                height: (imageHeight)+'px'
            }, 250);
            if (scrollTo) {
                setTimeout(function() {
                    $('html,body').animate({scrollTop: $imageBox.offset().top - titleHeight - $('header').outerHeight() - 36}, 250);
                }, 50);
            }
        } else {
            $trigger.data('status', 0);   
            $trigger.removeClass('opened');
            $animateParent.animate({
                height: titleHeight+'px'
            }, 50);
            $imageBox.animate({
                height: '0px'
            }, 50);
            $trigger.blur();
        }            
    },

    init = function(){
        var self = this;
        this.isOnLoad = true;

        if (Foundation.MediaQuery.atLeast('medium')) {
            $('body').on('mouseover', '.feature-title', function(e) {
                e.preventDefault();
                var id = $(this).data('id');
                self.showFeatureImage(id, true);
            });

            $('body').on('mouseout', '.feature-title', function(e) {
                e.preventDefault();
                var id = $(this).data('id');
                self.showFeatureImage(id);
                
            });
            var $contactFeature = $('.feature-title').last();
            var contactFeatureText = $contactFeature.find('.text').html();
            $contactFeature.find('.text').empty().html('<a href="#contact">'+contactFeatureText+'</a>');
        } else {
            this.$triggerFtImgSmall.each(function() {
                $(this).attr('data-height',($(this).outerHeight()+1));
            });
            // special handling for the last item: add Contact button
            var $contactFeature = this.$triggerFtImgSmall.last();
            $contactFeature
                .next()
                .append('<div class="contact-button-container text-center"><a href="#contact" class="button contact-us">Contact Us</a></div>');
            // open/close feature animation panel on title click
            $('body').on("click", '.trigger-ft-img-small', function() {
                var $target = $(this).closest('.trigger-ft-img-small');
                var id = $target.data('id');
                open = $target.data('status');
                var $otherOpened = $('.trigger-ft-img-small.opened');
                if ($otherOpened.length > 0) {
                    self.showFeatureImageSmall($otherOpened.data('id'), false);
                }
                if (open == 0) {
                    self.showFeatureImageSmall(id, true, true);
                } else {
                    self.showFeatureImageSmall(id, false);
                }            
            });    
        }

        var $cellFeatureContent = this.$panelFeatures.find(".cell-feature-content");

        if (Foundation.MediaQuery.atLeast("medium")) {
            animateHandler.animateScroll($cellFeatureContent, 3);
            animateHandler.animateFadeIn(this.$noteText);    
        } else {
            this.showFeatureImageSmall(1, true, false);
        }

        this.$window.resize(function(){
            clearTimeout(self.resizeTimeout);
            self.resizeTimeout = setTimeout(function() {
                if (self.isOnLoad) {
                    self.isOnLoad = false;   
                } else {            
                    var windowWidth = $window.width();
                    if (windowWidth != self.lastWindowWidth) {
                        animateHandler.animateScroll($cellFeatureContent, 3, true);
                        self.lastWindowWidth = windowWidth;
                    }
                }   
            }, 25);
        });

        
    }
}